import script from "./NotificationMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationMobile.vue?vue&type=script&setup=true&lang=js"

import "./NotificationMobile.vue?vue&type=style&index=0&id=06338562&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06338562"]])

export default __exports__